import { TemplatesType } from "@rjsf/utils";

import {
  ButtonTemplates,
  CustomArrayFieldTemplate,
  CustomFieldTemplate,
  CustomObjectFieldTemplate,
} from "./features/form-templates";

type OverrideTemplates<T = Partial<TemplatesType>> = Partial<TemplatesType> & T;

export const TEMPLATES: OverrideTemplates<{
  ButtonTemplates: TemplatesType["ButtonTemplates"];
}> = {
  ObjectFieldTemplate: CustomObjectFieldTemplate,
  FieldTemplate: CustomFieldTemplate,
  ArrayFieldTemplate: CustomArrayFieldTemplate,
  DescriptionFieldTemplate: () => null,
  TitleFieldTemplate: () => null,
  ButtonTemplates,
};
